import script from "./SettingsPageTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsPageTitle.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsPageTitle.vue?vue&type=style&index=0&id=ff22a720&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff22a720"]])

export default __exports__